/** Remove todo DOM/script do NPS IndeCX (evita vazar para outras rotas da SPA). */
export function cleanupIndecxNpsWidget() {
  window.__INDECX_WIDGET_LOADED__ = false;

  const scriptEl = document.getElementById('indecx-widget-js');
  if (scriptEl) scriptEl.remove();

  [
    'indecx-widget-container',
    'indecx-widget-minimized',
    'indecx-widget',
    'indecx-iframe',
    'indecx-widget-content',
    'indecx-widget-close-btn',
    'indecx-widget-modal',
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.remove();
  });

  document.querySelectorAll('[id^="indecx-"]').forEach((el) => el.remove());
}
